var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpeed2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 39.885,
    height: 57.9874,
    viewBox: "0 0 39.885 57.9874",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.3447 26.3034L16.3943 9.4112L4.93041 0.548777C4.46379 0.189233 3.89627 0 3.2783 0C2.57206 0 1.84689 0.258619 1.29198 0.706471C0.365035 1.4634 -0.189875 2.95204 0.491148 4.13159L8.39227 17.851C9.74171 20.1975 10.8831 22.6512 11.9803 25.5843C13.0018 28.3156 12.8631 29.5456 11.8604 32.3589C10.902 35.0397 9.63451 37.7836 7.86259 41.0069C5.47901 45.334 3.11435 49.3331 0.617271 53.2313C-0.315983 54.6947 -0.183569 56.278 0.96408 57.2683C1.51268 57.7414 2.15587 57.9874 2.83689 57.9874C3.54944 57.9874 4.28722 57.7098 4.97455 57.1926L38.6284 31.4317C39.5049 30.7567 39.9148 29.8736 39.8833 28.7193C39.8517 27.5398 39.1077 26.8711 38.3447 26.2908V26.3034ZM36.9133 28.9716C36.8754 29.0095 36.8187 29.0599 36.7115 29.1419L15.8205 45.0691L3.18371 54.7893L4.8043 52.2158L11.0344 41.3601C12.6487 38.5405 15.5745 32.0183 15.6376 29.041C15.6691 27.6596 15.398 26.234 14.8115 24.6886C13.6071 21.5032 12.3523 18.8287 10.8767 16.2614L3.22786 2.98989C3.22786 2.98989 3.22785 2.98989 3.23416 2.98989L25.3737 20.065L36.7304 28.795C36.8313 28.8707 36.888 28.9275 36.9259 28.9716H36.9133Z",
    fill: "#94F608"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeed2);
export default __webpack_public_path__ + "static/media/icon-speed-2.efdb35aa15f50af28da54ac4faec1c53.svg";
export { ForwardRef as ReactComponent };